import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const localizeLanguage = (locale: HgSupportedLanguage): string => {
  return locale === HgSupportedLanguage.EN ? locale : `${locale}-CH`;
};
